import React from 'react'
import { useTranslation } from 'react-i18next'
import ShowPayments from '../components/payments/ShowPayments'

const Payments:React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='mt-20'>
      <h2 className="text-2xl font-bold text-center text-gray-800 mb-6 uppercase tracking-wide">
        {t("Paiements")}
      </h2>
      <ShowPayments />
    </div>
  )
}

export default Payments
